import { FOfferType } from '../../utils/category';

export enum EAreaMeasure {
  meters = 'м\u00B2',
  weaving = 'сот.',
}

/**
 * Возвращает в зависимости от типа недвижимости меру площади:
 * метры квадратные или сотки.
 * @param offerType
 */
export function getAreaMeasure(offerType: FOfferType): string {
  switch (offerType) {
    case FOfferType.Land:
    case FOfferType.CommercialLand:
      return EAreaMeasure.weaving;
    default:
      return EAreaMeasure.meters;
  }
}
